import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ' ', ' ', ';\n'], ['\n  ', ' ', ' ', ';\n']);

import styled from 'styled-components';
import { onClickStyle, truncateStyle, cellStyle } from './constants';

export var TableBodyCell = styled.td(_templateObject, function (props) {
  return onClickStyle(props);
}, function (props) {
  return truncateStyle(props);
}, cellStyle);